import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-picnics',
  templateUrl: './picnics.component.html',
  styleUrls: ['./picnics.component.scss']
})
export class PicnicsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
